import { SeoHead } from "@/components/SeoHead"

export default function BookApprovalNotFound({ seo }) {
  return (
    <>
      <SeoHead seo={{ ...seo, noIndex: true }}>
        <meta name="robots" content="noindex, nofollow" />
      </SeoHead>
      <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-6">
        <div className="w-full max-w-lg space-y-4 text-center">
          <h1 className="font-display text-2xl">This link no longer works</h1>
          <p className="text-zinc-600">
            Your coach may have sent you a newer link, or the book has gone to print. Ask your coach for the latest link.
          </p>
        </div>
      </div>
    </>
  )
}
